import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'

import { SolarSSOLogin, SAMLLoginUrl } from '../components/Register/cognito'
import store from '../store/store'
import * as Sentry from '@sentry/vue'
import { formatarObjetoWebParaSentry } from '../sentry.ts'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (...rota) => {
  const [to, from, next] = rota
  const { accessData } = store.state
  const cognitoToken = accessData.cognitoInfo ? accessData.cognitoInfo.accessToken : false
  const regularToken = accessData.regularToken
  const acessoColetor = accessData.coletor
  const coletor = store.state.coletor
  const { sincronizacaoUsuario } = store.state.sincronizador

  store.commit('atribuiRotaAnterior', from)

  const rotasDeLoginComSSO = {
    BV: window.location.href.includes('?user_pool_id='),
    SOLAR: window.location.href.includes('/login?token=')
  }

  const utilizaLoginComSSO = [...Object.values(rotasDeLoginComSSO)].some(Boolean) && from.name == null

  if (!regularToken) {
    Sentry.captureEvent({
      message: 'Antes de entrar numa rota não recebeu o regularToken.',
      contexts: {
        localStorage: {
          web: formatarObjetoWebParaSentry(window.localStorage.getItem('web'))
        }
      }
    })
  }

  if (utilizaLoginComSSO) {
    // DO NOT DISPATCH 'logout' INSIDE THIS IF
    if (rotasDeLoginComSSO.SOLAR) {
      await SolarSSOLogin(...rota)
      return
    } else if (rotasDeLoginComSSO.BV) {
      await SAMLLoginUrl()
      return
    }
  }

  // check was redirected from saml
  if (window.location.href.includes('?user_pool_id=') && from.name == null) {
    await SAMLLoginUrl()
    return
  }

  const estaLogadoComSAML = accessData.cognitoInfo && accessData.cognitoInfo.isSamlLogin
  const estaLogadoComSSOSolar = store.state.accessData.solarInfo

  if ((estaLogadoComSAML || estaLogadoComSSOSolar) && !['marcacao', 'confirmacaoDados', 'confirmacaoPonto', 'historicoMarcacao', 'logout', 'clear'].includes(to.name)) {
    // already signed with SSO
    try {
      await store.dispatch('sincronizador/fazerSincronizacaoWebSSO')
      return
    } catch (e) {
      await store.dispatch('logout')
      return
    }
  }

  if (window.location.pathname.includes('index.html')) {
    const pathName = window.location.pathname
    const pathNameTratado = pathName.split('index.html')[0] + '#' + to.path
    window.location.href = window.origin + pathNameTratado
    next()
  }

  if (to.name === 'logout') {
    store.dispatch('logout')
  }

  if (to.name === 'clear') {
    store.dispatch('clear')
  }

  // load visual anyway, the action knows if really need, so, maybe the request are not made
  const rotasAposLoginColetor = ['sincronizador', 'marcacao', 'confirmacaoDados', 'confirmacaoPonto', 'historicoMarcacao']

  if (rotasAposLoginColetor.includes(to.name)) {
    await store.dispatch('getVisual')
  }

  // Verifica se existe coletor pendente

  if (to.name === 'listaColetores' || to.name === 'triagemColetor') {
    next('/criar-coletor')
    return
  }
  if (to.name !== 'coletorPendente' && acessoColetor.coletorPendente && acessoColetor.coletorId) {
    next('/coletor-pendente')
    return
  }
  if (to.name === 'coletorPendente' && !acessoColetor.coletorPendente) {
    next('/')
    return
  }
  if (to.name === 'register' && ((regularToken || cognitoToken) || acessoColetor.tokenColetor)) {
    const temColetores = coletor.coletores.lista

    if (acessoColetor.tokenColetor) {
      next('/')
      return
    } else {
      Sentry.captureEvent({
        message: 'Coletor tokenColetor nulo ou vazio.',
        contexts: {
          localStorage: {
            web: formatarObjetoWebParaSentry(window.localStorage.getItem('web'))
          }
        }
      })
    }
    if (temColetores.length) {
      next('/criar-coletor')
      return
    }

    next()
  }
  if (to.meta.precisaColetor && !coletor.coletores.lista.length) {
    next('/login')
    return
  }
  if (to.meta.precisaTokenMarcacao && !acessoColetor.tokenColetor) {
    next('/login')
    return
  }
  if (to.meta.precisaEmpregadoSincronizado && !sincronizacaoUsuario.empregado) {
    next('/')
    return
  }
  if (to.meta.precisaTokenLogin && !(regularToken || cognitoToken)) {
    next('/login')
    return
  }
  if (to.meta.naoPodeTerChaveAcesso && acessoColetor.tokenColetor) {
    next('/')
    return
  }
  next()
})

export default router
